import React, { useState, useEffect } from 'react';
import { node } from 'prop-types';
import css from './PasswordProtection.module.css';

const STORAGE_KEY = 'site_access_granted';
// eslint-disable-next-line no-undef
const SITE_PASSWORD = process.env.REACT_APP_SITE_PASSWORD;

const PasswordProtection = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [password, setPassword] = useState('');
  const [error, setError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const hasAccess = localStorage.getItem(STORAGE_KEY) === 'true';
      setIsAuthenticated(hasAccess);
      setIsLoading(false);
    }
  }, []);

  if (!SITE_PASSWORD || SITE_PASSWORD.trim() === '') {
    return children;
  }

  if (isLoading) {
    return null;
  }

  if (isAuthenticated) {
    return children;
  }

  const handleSubmit = e => {
    e.preventDefault();
    if (password === SITE_PASSWORD) {
      localStorage.setItem(STORAGE_KEY, 'true');
      setIsAuthenticated(true);
      setError(false);
    } else {
      setError(true);
      setPassword('');
    }
  };

  return (
    <div className={css.root}>
      <div className={css.container}>
        <div className={css.brandText}>FREITAG PRELOVED</div>
        <div className={css.formWrapper}>
          <form onSubmit={handleSubmit} className={css.form}>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="ENTER PASSWORD"
              className={css.input}
              autoFocus
            />
            <button type="submit" className={css.button}>
              →
            </button>
          </form>
          {error && <div className={css.error}>INCORRECT PASSWORD</div>}
        </div>
      </div>
    </div>
  );
};

PasswordProtection.propTypes = {
  children: node.isRequired,
};

export default PasswordProtection;
